/**
 * The Scaling step's collapsed summary, in the operator's words.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { ContainerDraft } from '../../../../drop-generator.types';

export function scalingSummary(draft: ContainerDraft): string {
  const { scaling, scalingEnabled } = draft;
  if (!scalingEnabled) return 'off — amounts stay as planned';
  if (scaling.performing.advanced) return 'advanced rule tree (edit via API)';
  const shrinks = scaling.weak.advanced || scaling.weak.rows.length > 0;
  if (scaling.performing.rows.length === 0 && !shrinks) return 'on, but no performing or weak rule yet — amounts stay as planned';
  const cap = scaling.maxAmount ? ` · up to ${scaling.maxAmount.toLocaleString('en-US')}` : ' · no amount cap';
  const guard = scaling.guard.rows.length > 0 ? ` · ${scaling.guard.rows.length} guard` : '';
  const grow = scaling.performing.rows.length > 0 || scaling.performing.advanced ? `+${scaling.stepPct} % per performing check${cap}${guard}` : 'no performing rule';
  return shrinks ? `${grow} · −${scaling.shrinkPct} % per weak check` : grow;
}
